export enum EnumTipoRelatorioPessoaExcel {
  Cliente = 0,
  Contrato = 1,
  Modulo = 2,
}
